import { TokenStorageService } from './../../../../@core/services/token-storage.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { CoreConfigService } from '@core/services/config.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HistoryComponent implements OnInit {

  public contentHeader: object;
  public transactions: any = []

  public user: any
  public siteSettings: any = {
    site_logo: '',
    site_name: ''
  };
  submitted: boolean = false
  disable: boolean = false
  old_pin: any
  new_pin: any;

  constructor(
    private tokenStorage: TokenStorageService,
    private _coreConfigService: CoreConfigService,
    private api: ApiService
  ) {
    
  }

  ngOnInit(): void {

    if (this.tokenStorage.getToken()) {
      this.user = this.tokenStorage.getUser();
    }

    // this.api.externalGet('list-service-category&serviceID=12').subscribe((response: any) => {
    //   this.selectBasic = response.data; 
    // });
    this._coreConfigService.sysConfig().subscribe(config => {
      console.log("site settings: ", config)
      this.siteSettings = config.data;
    });

    // content header
    this.contentHeader = {
      headerTitle: 'Transaction History',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/dashboard'
          },
          {
            name: 'Transaction History',
            isLink: false
          }
        ]
      }
    };

    const limit = {
      limit: "10"
    }
    this.api.post('fetch-transactions-limit', limit).subscribe((response: any) => {
      this.transactions = response.data; 
    });
  }

}
